import { render, staticRenderFns } from "./SchedulingAppointment.vue?vue&type=template&id=40febdcc&scoped=true"
import script from "./SchedulingAppointment.vue?vue&type=script&lang=ts"
export * from "./SchedulingAppointment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40febdcc",
  null
  
)

export default component.exports